import { render, staticRenderFns } from "./SearchGalleryHeader.vue?vue&type=template&id=fb3ba036&scoped=true"
import script from "./SearchGalleryHeader.vue?vue&type=script&lang=js"
export * from "./SearchGalleryHeader.vue?vue&type=script&lang=js"
import style0 from "./SearchGalleryHeader.vue?vue&type=style&index=0&id=fb3ba036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3ba036",
  null
  
)

export default component.exports